import React, { FC } from "react";
import { faCoins } from "@fortawesome/pro-regular-svg-icons/faCoins";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const Coins: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faCoins} {...props} />
);
